export function parseIntFromString(number, defaultValue = null) {
    let result = defaultValue;
    if (number?.length > 0 && !isNaN(number)) {
        result = parseInt(number, 10);
    }
    return result;
}
